var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
import { inject, singleton } from "tsyringe";
import { makeImmutable } from "../core";
import { GlobalConfig } from "../config";
import { LocalizationProvider } from "../locale";
import { RestaumaticRPCService } from "./RestaumaticRPCService";
let NewsletterSubscriptionService = class NewsletterSubscriptionService {
    constructor(rpcService, localizationProvider, globalConfig) {
        this.rpcService = rpcService;
        this.localizationProvider = localizationProvider;
        this.siteId = globalConfig.siteId;
        makeImmutable(this);
    }
    /** Backend answers with a double opt-in confirmation mail, not an active subscription. */
    async subscribe(params) {
        var _a;
        const result = await this.rpcService.rpc("SubscribeToNewsletter", {
            siteId: this.siteId,
            email: params.email.value,
            marketingConsent: params.marketingConsent,
            marketingRestaumaticConsent: params.marketingRestaumaticConsent,
            locale: this.localizationProvider.locale,
            website: params.website,
            elapsedMs: params.elapsedMs,
        });
        // rpc() collapses a transport failure and an rpc-level error to null;
        // both read the same as a rejected subscription here.
        return {
            success: (result === null || result === void 0 ? void 0 : result.success) === true,
            trackingId: (_a = result === null || result === void 0 ? void 0 : result.trackingId) !== null && _a !== void 0 ? _a : null,
        };
    }
    async resend(params) {
        const result = await this.rpcService.rpc("ResendNewsletterConfirmation", {
            siteId: this.siteId,
            email: params.email.value,
        });
        return result === true;
    }
};
NewsletterSubscriptionService = __decorate([
    singleton(),
    __param(2, inject(GlobalConfig)),
    __metadata("design:paramtypes", [typeof (_a = typeof RestaumaticRPCService !== "undefined" && RestaumaticRPCService) === "function" ? _a : Object, typeof (_b = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _b : Object, typeof (_c = typeof GlobalConfig !== "undefined" && GlobalConfig) === "function" ? _c : Object])
], NewsletterSubscriptionService);
export { NewsletterSubscriptionService };
